document.addEventListener('DOMContentLoaded', () => {
  // Don't run on investments, using own custom menu. See investments tax-nav.js.
  if (document.getElementById('page').classList.contains('investments')) {
    return;
  }

  document.addEventListener('click', event => {
    // Grab all the li elements
    const list = document.querySelectorAll('ul#menu-primary > li');
    const primaryMenu = document.querySelectorAll('div.primaryNav--desktop')[0];
    for (let i = 0; i < list.length; i += 1) {
      if (event.target === list[i]) {
        if (event.target.classList.contains('inactive')) {
          list.forEach(node => {
            node.classList.remove('active');
            node.classList.add('inactive');
          });
          event.target.classList.add('active');
          event.target.classList.remove('inactive');
        } else {
          event.target.classList.add('inactive');
          event.target.classList.remove('active');
        }
      } else if (primaryMenu !== event.target) {
        list[i].classList.add('inactive');
        list[i].classList.remove('active');
      }
    }
  });
});
